var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 60,
    viewBox: "0 0 204 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.231%",
    y1: "4.839%",
    x2: "26.324%",
    y2: "71.968%",
    id: "0rrzlddaxa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: ".657%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51.22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76.04%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.728%",
    y1: "49.428%",
    x2: "-130.665%",
    y2: "49.428%",
    id: "mymmo8t52b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "40.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "orange",
    offset: "77.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.389%",
    y1: "30.83%",
    x2: "-49.888%",
    y2: "136.004%",
    id: "rq5ewh92pc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.579%",
    y1: "-11.682%",
    x2: "42.275%",
    y2: "35.064%",
    id: "knzwwvxdid"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "6.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "47.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.8 60H8.3C4.1 60 .8 56.7.8 52.5v-45C.8 3.3 4.1 0 8.3 0h187.5c4.2 0 7.5 3.3 7.5 7.5v45c0 4.05-3.3 7.5-7.5 7.5z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8 1.2c3.45 0 6.3 2.85 6.3 6.3v45c0 3.45-2.85 6.3-6.3 6.3H8.3c-3.45 0-6.3-2.85-6.3-6.3v-45c0-3.45 2.85-6.3 6.3-6.3h187.5m0-1.2H8.3C4.1 0 .8 3.3.8 7.5v45c0 4.2 3.3 7.5 7.5 7.5h187.5c4.2 0 7.5-3.3 7.5-7.5v-45c0-4.05-3.3-7.5-7.5-7.5z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9 15.3c0 1.2-.3 2.25-1.05 3-.9.9-1.95 1.35-3.3 1.35-1.35 0-2.4-.45-3.3-1.35-.9-.9-1.35-1.95-1.35-3.3 0-1.35.45-2.4 1.35-3.3.9-.9 1.95-1.35 3.3-1.35.6 0 1.2.15 1.8.45.6.3 1.05.6 1.35 1.05l-.75.75c-.6-.75-1.35-1.05-2.4-1.05-.9 0-1.8.3-2.4 1.05-.75.6-1.05 1.5-1.05 2.55 0 1.05.3 1.95 1.05 2.55.75.6 1.5 1.05 2.4 1.05 1.05 0 1.8-.3 2.55-1.05.45-.45.75-1.05.75-1.8h-3.3v-1.05h4.35v.45zM78.8 11.55h-4.05v2.85h3.75v1.05h-3.75v2.85h4.05v1.2h-5.25v-9h5.25zM83.75 19.5h-1.2v-7.95H80V10.5h6.3v1.05h-2.55zM90.65 19.5v-9h1.2v9zM96.95 19.5h-1.2v-7.95H93.2V10.5h6.15v1.05H96.8v7.95zM111.2 18.3c-.9.9-1.95 1.35-3.3 1.35-1.35 0-2.4-.45-3.3-1.35-.9-.9-1.35-1.95-1.35-3.3 0-1.35.45-2.4 1.35-3.3.9-.9 1.95-1.35 3.3-1.35 1.35 0 2.4.45 3.3 1.35.9.9 1.35 1.95 1.35 3.3 0 1.35-.45 2.4-1.35 3.3zm-5.7-.75c.6.6 1.5 1.05 2.4 1.05.9 0 1.8-.3 2.4-1.05.6-.6 1.05-1.5 1.05-2.55 0-1.05-.3-1.95-1.05-2.55-.6-.6-1.5-1.05-2.4-1.05-.9 0-1.8.3-2.4 1.05-.6.6-1.05 1.5-1.05 2.55 0 1.05.3 1.95 1.05 2.55zM114.2 19.5v-9h1.35l4.35 7.05V10.5h1.2v9h-1.2l-4.65-7.35v7.35z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.95 32.7c-3.6 0-6.45 2.7-6.45 6.45 0 3.6 2.85 6.45 6.45 6.45s6.45-2.7 6.45-6.45c0-3.9-2.85-6.45-6.45-6.45zm0 10.2c-1.95 0-3.6-1.65-3.6-3.9s1.65-3.9 3.6-3.9c1.95 0 3.6 1.5 3.6 3.9 0 2.25-1.65 3.9-3.6 3.9zM89 32.7c-3.6 0-6.45 2.7-6.45 6.45 0 3.6 2.85 6.45 6.45 6.45s6.45-2.7 6.45-6.45c0-3.9-2.85-6.45-6.45-6.45zm0 10.2c-1.95 0-3.6-1.65-3.6-3.9s1.65-3.9 3.6-3.9c1.95 0 3.6 1.5 3.6 3.9 0 2.25-1.65 3.9-3.6 3.9zm-16.65-8.25v2.7h6.45c-.15 1.5-.75 2.7-1.5 3.45-.9.9-2.4 1.95-4.95 1.95-4.05 0-7.05-3.15-7.05-7.2 0-4.05 3.15-7.2 7.05-7.2 2.1 0 3.75.9 4.95 1.95l1.95-1.95c-1.65-1.5-3.75-2.7-6.75-2.7-5.4 0-10.05 4.5-10.05 9.9s4.65 9.9 10.05 9.9c3 0 5.1-.9 6.9-2.85 1.8-1.8 2.4-4.35 2.4-6.3 0-.6 0-1.2-.15-1.65h-9.3zm68.1 2.1c-.6-1.5-2.1-4.05-5.4-4.05-3.3 0-6 2.55-6 6.45 0 3.6 2.7 6.45 6.3 6.45 2.85 0 4.65-1.8 5.25-2.85l-2.1-1.5c-.75 1.05-1.65 1.8-3.15 1.8s-2.4-.6-3.15-1.95l8.55-3.6-.3-.75zm-8.7 2.1c0-2.4 1.95-3.75 3.3-3.75 1.05 0 2.1.6 2.4 1.35l-5.7 2.4zM124.7 45h2.85V26.25h-2.85V45zm-4.5-10.95c-.75-.75-1.95-1.5-3.45-1.5-3.15 0-6.15 2.85-6.15 6.45s2.85 6.3 6.15 6.3c1.5 0 2.7-.75 3.3-1.5h.15v.9c0 2.4-1.35 3.75-3.45 3.75-1.65 0-2.85-1.2-3.15-2.25l-2.4 1.05c.75 1.65 2.55 3.75 5.7 3.75 3.3 0 6-1.95 6-6.6V33h-2.7v1.05zm-3.3 8.85c-1.95 0-3.6-1.65-3.6-3.9s1.65-3.9 3.6-3.9c1.95 0 3.45 1.65 3.45 3.9s-1.5 3.9-3.45 3.9zm36.6-16.65h-6.75V45h2.85v-7.05h3.9c3.15 0 6.15-2.25 6.15-5.85 0-3.6-3-5.85-6.15-5.85zm.15 9h-4.05V28.8h4.05c2.1 0 3.3 1.8 3.3 3.15-.15 1.65-1.35 3.3-3.3 3.3zm17.25-2.7c-2.1 0-4.2.9-4.95 2.85l2.55 1.05c.6-1.05 1.5-1.35 2.55-1.35 1.5 0 2.85.9 3 2.4v.15c-.45-.3-1.65-.75-2.85-.75-2.7 0-5.4 1.5-5.4 4.2 0 2.55 2.25 4.2 4.65 4.2 1.95 0 2.85-.9 3.6-1.8h.15V45h2.7v-7.2c-.3-3.3-2.85-5.25-6-5.25zm-.3 10.35c-.9 0-2.25-.45-2.25-1.65 0-1.5 1.65-1.95 3-1.95 1.2 0 1.8.3 2.55.6-.3 1.8-1.8 3-3.3 3zm15.75-9.9-3.15 8.1h-.15l-3.3-8.1h-3l4.95 11.4-2.85 6.3h2.85l7.65-17.7h-3zm-25.2 12H164V26.25h-2.85V45z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.975.499c-.45.45-.75 1.2-.75 2.1v33.15c0 .9.3 1.65.75 2.1l.15.15 18.6-18.6v-.3L.975.499z",
    fill: "url(#0rrzlddaxa)",
    transform: "translate(15.425 10.751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.875 25.699-6.15-6.15V19.099l6.15-6.15.15.15 7.35 4.2c2.1 1.2 2.1 3.15 0 4.35l-7.5 4.05z",
    fill: "url(#mymmo8t52b)",
    transform: "translate(15.425 10.751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.025 25.549-6.3-6.3-18.75 18.75c.75.75 1.8.75 3.15.15l21.9-12.6",
    fill: "url(#rq5ewh92pc)",
    transform: "translate(15.425 10.751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.025 12.949 4.125.499c-1.35-.75-2.4-.6-3.15.15l18.75 18.6 6.3-6.3z",
    fill: "url(#knzwwvxdid)",
    transform: "translate(15.425 10.751)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.3 36.15-21.75 12.3c-1.2.75-2.25.6-3 0l-.15.15.15.15c.75.6 1.8.75 3 0l21.75-12.6z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 48.45c-.45-.45-.6-1.2-.6-2.1v.15c0 .9.3 1.65.75 2.1v-.15h-.15z",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("path", {
    d: "m48.8 31.95-7.5 4.2.15.15 7.35-4.2c1.05-.6 1.5-1.35 1.5-2.1 0 .75-.6 1.35-1.5 1.95z",
    fill: "#000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.55 11.4 48.8 28.05c.9.6 1.5 1.2 1.5 1.95 0-.75-.45-1.5-1.5-2.1L19.55 11.25c-2.1-1.2-3.75-.15-3.75 2.25v.15c0-2.4 1.65-3.45 3.75-2.25z",
    fill: "#FFF",
    opacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGooglePlay);
export default __webpack_public_path__ + "static/media/button-google-play.d0c10d9412feaa83e5c6466dffafbb19.svg";
export { ForwardRef as ReactComponent };